<template>
  <div class="pmr-page">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />

    <div class="pmr-header">
      <div class="pmr-title">My PMR Score</div>
      <v-select
        v-model="financialYear"
        :items="financialYears"
        label="Financial Year"
        outlined
        dense
        hide-details
        class="pmr-year-select"
      ></v-select>
    </div>

    <template v-if="pmr">
      <div class="pmr-banner">
        <span>PMR Rating</span>
        <span class="pmr-banner-value">{{ fmt(pmr.rating) }} <small>/ {{ max.rating }}</small></span>
      </div>

      <div class="pmr-table-wrap">
      <table class="pmr-table">
        <thead>
          <tr>
            <th>Score Matrix</th>
            <th>Quantitative Assessment<small>Section A</small></th>
            <th>Qualitative Assessment<small>Section B</small></th>
            <th>PI Rating<small>Section C</small></th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Max Marks</td>
            <td>{{ max.quantitative }}</td>
            <td>{{ max.qualitative }}</td>
            <td>{{ max.pi }}</td>
            <td>{{ max.total }}</td>
          </tr>
          <tr>
            <td>Score</td>
            <td>{{ fmt(pmr.quantitativeScore) }}</td>
            <td>{{ fmt(pmr.qualitativeScore) }}</td>
            <td>{{ fmt(pmr.piRating) }}</td>
            <td>{{ fmt(pmr.totalScore) }}</td>
          </tr>
        </tbody>
      </table>
      </div>

      <div class="pmr-row">
        <span>Quantitative Assessment (Target Sheet)</span>
        <span class="pmr-value">{{ fmt(pmr.quantitativeScore) }}</span>
      </div>
      <div class="pmr-row">
        <span>Qualitative Assessment (Behavioral Competence)</span>
        <span class="pmr-value">{{ fmt(pmr.qualitativeScore) }}</span>
      </div>
      <div class="pmr-row">
        <span>PI Rating</span>
        <span class="pmr-value">{{ fmt(pmr.piRating) }}</span>
      </div>

      <div class="pmr-comments">
        <div class="pmr-comments-title">Reviewer's Additional Comments</div>
        <div class="pmr-comments-text">{{ pmr.reviewerComments || "-" }}</div>
      </div>
    </template>

    <div v-else-if="!appLoading" class="pmr-empty">
      No PMR available for {{ financialYear }}
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      pmr: null,
      max: { quantitative: 60, qualitative: 20, pi: 20, total: 100, rating: 10 },
      financialYear: "",
      financialYears: [],
    };
  },
  mounted() {
    this.generateFinancialYears();
  },
  watch: {
    financialYear() {
      this.getData();
    },
  },
  methods: {
    // Records added before the detailed scores existed have no value
    fmt(v) {
      return v === undefined || v === null || v === "" ? "-" : v;
    },
    generateFinancialYears() {
      const now = new Date();
      // Financial year runs April - March
      const currentStart = now.getMonth() < 3 ? now.getFullYear() - 1 : now.getFullYear();
      const years = [];
      for (let y = currentStart + 1; y >= 2000; y--) {
        years.push(`${y}-${y + 1}`);
      }
      this.financialYears = years;
      // Setting this triggers the watcher, which loads the data
      this.financialYear = `${currentStart}-${currentStart + 1}`;
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/pmr/my",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          fyear: this.financialYear,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.pmr = response.data.data;
            if (response.data.max) {
              this.max = { ...this.max, ...response.data.max };
            }
          } else {
            this.pmr = null;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.pmr = null;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.pmr-page {
  padding: 24px;
  width: 100%;
  font-family: kumbhRegular;
}
.pmr-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
}
.pmr-title {
  font-family: kumbhMedium;
  font-size: 22px;
  color: #005f32;
}
.pmr-year-select {
  max-width: 220px;
}
.pmr-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #005f32;
  color: #ffffff;
  font-family: kumbhMedium;
  font-size: 18px;
  padding: 14px 20px;
  border-radius: 10px;
}
.pmr-banner-value {
  font-size: 24px;
}
.pmr-banner-value small {
  font-size: 14px;
  opacity: 0.8;
}
.pmr-table-wrap {
  margin-top: 16px;
  overflow-x: auto;
  border: 1px solid #dfe7e2;
  border-radius: 10px;
}
.pmr-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  text-align: center;
  font-size: 14px;
}
.pmr-table th,
.pmr-table td {
  padding: 10px 14px;
}
.pmr-table th {
  background: #e4efe7;
  color: #005f32;
  font-family: kumbhMedium;
  font-weight: normal;
}
.pmr-table th small {
  display: block;
  color: #6b7a71;
  font-size: 12px;
}
.pmr-table td {
  border-top: 1px solid #edf2ee;
}
.pmr-table tbody tr:last-child td {
  font-family: kumbhMedium;
}
.pmr-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding: 12px 20px;
  background: #ffffff;
  border: 1px solid #dfe7e2;
  border-left: 5px solid #005f32;
  border-radius: 8px;
  font-family: kumbhMedium;
  font-size: 16px;
}
.pmr-value {
  font-size: 20px;
  color: #005f32;
}
.pmr-comments {
  margin-top: 32px;
  background: #ffffff;
  border: 1px solid #dfe7e2;
  border-radius: 10px;
  text-align: left;
  overflow: hidden;
}
.pmr-comments-title {
  padding: 12px 20px;
  background: #f6f9f7;
  border-bottom: 1px solid #dfe7e2;
  font-family: kumbhMedium;
  font-size: 15px;
  color: #005f32;
}
.pmr-comments-text {
  padding: 16px 20px;
  min-height: 72px;
  white-space: pre-wrap;
}
.pmr-empty {
  padding: 48px 0;
  text-align: center;
  color: #6b7a71;
}
</style>
